














import { Component, Prop, Vue } from 'vue-property-decorator';
import { Product, ProductFaultStatusEnum } from '@/api';
import InformationRow from '@/components/display/information-row.vue';

@Component({
	components: { InformationRow },
})
export default class FaultStatusRow extends Vue {
	@Prop({ required: true, type: Object })
	public product!: Product;

	private getFaultButtonStatusStyle() {
		switch (this.product?.faultStatus) {
			case ProductFaultStatusEnum.Resolved:
				return 'bg-success text-white';
			case ProductFaultStatusEnum.New:
				return 'bg-danger text-white';
			case null:
				return 'bg-transparent text-black';
			default:
				return 'bg-secondary text-white';
		}
	}

	private get faultButtonStyling() {
		return `${this.product.faultStatus ? 'p-1 px-4 ' : ''} ${this.getFaultButtonStatusStyle()}`;
	}
}
